module.exports =
{

  _init: function ()
  {

    this.onEditStock()
    this.onSubmitStockConfirm()

    this.onEditVehicle()
    this.onSubmitVehicleConfirm()

  },

  onEditStock: function ()
  {

    $('#edit-stock').not('.js-ignore').click(function ()
    {
      $(this).closest('.alert').remove()
    }).addClass('js-ignore')

  },

  onSubmitStockConfirm: function ()
  {

    $('#submit-stock-confirm').not('.js-ignore').click(function ()
    {

      $('#stock-confirm').val(1)

      $('#submit-stock').trigger('click')

    }).addClass('js-ignore')

  },

  onEditVehicle: function ()
  {

    $('#edit-vehicle').not('.js-ignore').click(function ()
    {
      
      $(this).closest('.alert').remove()

      location.hash = 'vehicle'

    }).addClass('js-ignore')

  },

  onSubmitVehicleConfirm: function ()
  {

    $('#submit-vehicle-confirm').not('.js-ignore').click(function ()
    {

      $('#vehicle-confirm').val(1)

      $('#submit-vehicle').trigger('click')

    }).addClass('js-ignore')

  }

}